import { Injectable } from '@angular/core';
import { dateFormat, DateValue } from '@web/utils';
import { DD_MM_YYYY } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class DateFormatService {
  public format(date: DateValue, format: string = DD_MM_YYYY): string {
    return dateFormat(date, format);
  }
}
